import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Options } from 'ngx-slider-v2';
import { AuthService } from '../../_services/auth.service';
import { TipoBeneficio } from './../../_models/Enums/tipoExperiencia';
import { FidelidadeService } from './../../_services/fidelidade.service';

@Component({
  selector: 'app-momentos-especiais',
  templateUrl: './momentos-especiais.component.html',
  styleUrls: ['./momentos-especiais.component.scss'],
})
export class MomentosEspeciaisComponent implements OnInit {
  private readonly MIN_VALUE_CACAUS: number = 0;
  private readonly MAX_VALUE_CACAUS: number = 150;

  private readonly TIPOS_EXPERIENCIA: any = `[${TipoBeneficio.Promocao},${TipoBeneficio.Experiencia},${TipoBeneficio.ComResgateDeProdutos}]`;

  public pesquisaForm: UntypedFormGroup;
  public experienciaNome: string = '';
  public nomeMomentoEspecial: string = '';
  public experiencias: any[] = [];
  public experienciasFilter: any[] = [];
  public quantidadeCards: number = null;
  public exibirPopup: boolean = false;
  public loadingAplicar: boolean = false;
  public buttonFiltrar: boolean = false;
  public membro: any;
  public readonly pagina: string = 'momentos-especiais';

  // Filtros
  public niveisLista: any[] = [];
  public estadosLista: any[] = [];
  public categoriasLista: any[] = [];
  public campanhasLista: any[] = [];
  public ordensLista: any[] = [
    {
      id: 1,
      descricao: 'Recentemente adicionadas',
    },
    {
      id: 2,
      descricao: 'Menor valor',
    },
    {
      id: 3,
      descricao: 'Maior valor',
    },
  ];

  public minValue: number = this.MIN_VALUE_CACAUS;
  public maxValue: number = this.MAX_VALUE_CACAUS;
  public maiorValor: number = 0;
  private existeCategoriaSocial: boolean = false;

  public options: Options = {
    floor: this.MIN_VALUE_CACAUS,
    ceil: this.MAX_VALUE_CACAUS,
    translate: (value: number): string => {
      return '';
    },
    getSelectionBarColor: (value: number): string => {
      return '#9A2225';
    },
  };

  public campanhaSelecionada: any = undefined;
  public ordemSelecionada: any = undefined;
  public textoPesquisa: string = null;

  public existeProduto: boolean = false;

  constructor(
    private FidelidadeService: FidelidadeService,
    private FormBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {
    this.pesquisaForm = this.FormBuilder.group({
      momentoEspecialNome: '',
    });

    this.route.queryParams.subscribe((params) => {
      const cacausRange = params['cacaus'];
      const categoriaSocial = params['categoria'];

      if (categoriaSocial == undefined) {
        return;
      }
      if (categoriaSocial === 'social') {
        this.existeCategoriaSocial = true;

        var objCategoria = { descricao: 'Social', valor: 8, selecionado: true };

        this.categoriasLista.push(objCategoria);
      }

      if (cacausRange == undefined && !this.existeCategoriaSocial) return;

      this.maxValue = cacausRange;
      this.obterFiltroRange();
    });
  }

  ngOnInit(): void {
    //this.carregarListaDeExperiencias();
    this.obterMembro();
    this.obterNiveisListados();
    this.obterEstadosListados();
    //this.obterCategoriasListados();
    this.obterCampanhasListados();
    setTimeout(() => {
      this.aplicarFiltros();
    }, 1000);
  }

  public sucessoAoObterExperiencias(experiencias: any) {
    this.experiencias = experiencias.resultado.filter(
      (experiencia: any) => experiencia.idCategoria !== 15
    );
    this.experienciasFilter = this.experiencias;
    this.quantidadeCards = this.experiencias.length;

    this.maiorValor = 0;

    for (let i = 0; i < this.experiencias.length; i++) {
      var element = Number(this.experiencias[i].precoEmCacaus);
      if (element > this.maiorValor) {
        this.maiorValor = element;
      }

      const categoria = this.categoriasLista.find(
        (categoria) => categoria.descricao === this.experiencias[i].categoria
      );

      if (categoria == undefined) {
        var objCategoria = {
          descricao: this.experiencias[i].categoria,
          valor: this.experiencias[i].idCategoria,
        };

        if (!this.categoriasLista.includes(objCategoria)) {
          this.categoriasLista.push(objCategoria);
        }
      }
    }
    const momentosProdutos = _.filter(
      experiencias.resultado,
      (experiencia: any) => {
        return experiencia?.idCategoria === 15;
      }
    );

    if (momentosProdutos.length > 0) this.existeProduto = true;
  }

  public erroAoObterExperiencias(error: any) {
    console.log('erro ao obter experiencias', error);
  }

  public obterNiveisListados() {
    this.FidelidadeService.obterNiveis().subscribe({
      next: (niveis: any) => this.tratarNiveis(niveis),
      error: (niveisErro: any) => console.log(niveisErro),
    });
  }

  public tratarNiveis(niveis: any) {
    for (let nivel of niveis) {
      nivel.selecionado = false;
    }

    niveis = _.orderBy(niveis, (nivel: any) => {
      return nivel.id;
    });

    this.niveisLista = niveis;
  }

  private obterCategoriasListados() {
    this.FidelidadeService.obterTiposExperiencias(
      'experiencia',
      'idcategoria',
      this.TIPOS_EXPERIENCIA
    ).subscribe({
      next: (categorias: any) => this.tratarCategorias(categorias),
      error: (categoriasErro: any) => console.log(categoriasErro),
    });
  }

  public obterCampanhasListados() {
    this.FidelidadeService.obterTiposExperiencias(
      'experiencia',
      'campanha',
      this.TIPOS_EXPERIENCIA
    ).subscribe({
      next: (campanhas: any) => (this.campanhasLista = campanhas),
      error: (campanhasErro: any) => console.log(campanhasErro),
    });
  }

  public tratarCategorias(res: any) {
    for (let item of res) {
      item.selecionado = false;
    }
    this.categoriasLista = res;
  }

  public selecionarNivel(index: number) {
    this.niveisLista[index].selecionado = !this.niveisLista[index].selecionado;
  }

  public selecionarEstado(index: number) {
    this.estadosLista[index].selecionado =
      !this.estadosLista[index].selecionado;
  }

  public selecionarCategoria(index: number) {
    this.categoriasLista[index].selecionado =
      !this.categoriasLista[index].selecionado;
  }

  public selecionarCampanha(campanha: any) {
    if (this.campanhaSelecionada?.id == campanha.id) {
      this.campanhaSelecionada = undefined;
      return;
    }
    this.campanhaSelecionada = campanha;
  }

  public selecionarOrdem(ordem: any) {
    if (this.ordemSelecionada?.id == ordem.id) {
      this.ordemSelecionada = undefined;
      return;
    }
    this.ordemSelecionada = ordem;
  }

  public obterEstadosListados() {
    this.FidelidadeService.listarEstados().subscribe({
      next: (estados: any) => this.sucessoAoObterEstadosListados(estados),
      error: (estadosErro: any) => console.log(estadosErro),
    });
  }

  private sucessoAoObterEstadosListados(res: any) {
    const estados: any[] = [];
    for (let item of res.resultado) {
      const estado = {
        nome: item,
        selecionado: false,
      };
      estados.push(estado);
    }

    let estadosOrdenados = _.sortBy(estados, (estado: any) => {
      return estado.nome;
    });

    this.estadosLista = estadosOrdenados;
  }

  public dadosCampoDePesquisa() {
    this.experienciaNome = this.pesquisaForm.value.momentoEspecialNome;
  }

  public filtrarMomentoPorNome() {
    if (this.experienciaNome != '') {
      let momentosEncontrados = _.filter(this.experiencias, (res: any) => {
        return res.nome
          .toLowerCase()
          .includes(this.experienciaNome.toLocaleLowerCase());
      });

      this.quantidadeCards = momentosEncontrados.length;

      return _.orderBy(momentosEncontrados, (experiencia: any) => {
        return parseInt(experiencia.precoEmCacaus.split('-')[0]);
      });
    }

    if (this.ordemSelecionada == undefined) {
      let ordenacaoPonto = _.orderBy(this.experiencias, (experiencia: any) => {
        return parseInt(experiencia.precoEmCacaus.split('-')[0]);
      });

      return _.orderBy(ordenacaoPonto, (experienciaDestaque: any) => {
        return !experienciaDestaque.destaque;
      });
    } else {
      return this.experiencias;
    }
  }

  public abrirPopupFiltros(exibir: boolean) {
    this.exibirPopup = exibir;
  }

  public limparFiltros(): void {
    this.campanhaSelecionada = undefined;
    this.ordemSelecionada = undefined;
    this.minValue = this.MIN_VALUE_CACAUS;
    this.maxValue = this.MAX_VALUE_CACAUS;
    for (let nivel of this.niveisLista) nivel.selecionado = false;
    for (let estado of this.estadosLista) estado.selecionado = false;
    for (let categorias of this.categoriasLista) categorias.selecionado = false;
  }
  public aplicarFiltros() {
    this.buttonFiltrar = false;
    this.loadingAplicar = true;
    this.experiencias = [];
    this.quantidadeCards = null;
    var filtroExperiencia: any = {
      tipos: this.TIPOS_EXPERIENCIA,
      niveis: this.obterFiltroNiveis(),
      estados: this.obterFiltroEstados(),
      categorias: this.obterFiltroCategorias(),
      campanhas: this.obterFiltroCampanhas(),
      ordem: this.obterFiltroOrdem(),
      descricao: this.textoPesquisa ?? '',
      rangeCacaus: this.existeCategoriaSocial ? null : this.obterFiltroRange(),
      ehTelaMomentoEspecial: true,
      pagina: this.pagina
    };

    this.FidelidadeService.searchExperiencias(filtroExperiencia).subscribe({
      next: (res: any) => {
        this.sucessoAoObterExperiencias(res);
        this.abrirPopupFiltros(false);
        this.loadingAplicar = false;
      },
      error: (err: any) => {
        this.loadingAplicar = false;
        this.abrirPopupFiltros(false);
        this.experiencias = [];
        this.quantidadeCards = 0;
      },
    });
  }

  private obterFiltroNiveis(): string {
    var result = '';

    const niveis = _.filter(this.niveisLista, (nivel: any) => {
      return nivel.selecionado;
    }).map((x) => x.id);

    if (niveis.length > 0) return this.obterString(niveis);

    return result;
  }

  private obterFiltroEstados(): string {
    var result = '';

    const estados = _.filter(this.estadosLista, (estado: any) => {
      return estado.selecionado;
    }).map((x) => x.nome);

    if (estados.length > 0) return this.obterString(estados);

    return result;
  }

  private obterFiltroCategorias(): string {
    // this.categoriasLista.forEach((categoria) => {
    //   if (this.existeCategoriaSocial && categoria.descricao === 'Social') {
    //     categoria.selecionado = true;
    //   }
    // });

    const categorias = _.filter(this.categoriasLista, (categoria: any) => {
      return categoria.selecionado;
    }).map((x) => x.valor);

    if (categorias.length > 0) return this.obterString(categorias);

    return '';
  }

  private obterFiltroCampanhas(): string {
    if (this.campanhaSelecionada != null) {
      return this.obterString([this.campanhaSelecionada.valor]);
    }
    return '';
  }

  private obterFiltroOrdem(): string {
    if (this.ordemSelecionada != null) {
      this.buttonFiltrar = true;
      return this.ordemSelecionada.id;
    }
    return '';
  }

  private obterFiltroRange(): string {
    const list = [this.minValue, this.maxValue];

    if (
      this.minValue == this.MIN_VALUE_CACAUS &&
      this.maxValue == this.MAX_VALUE_CACAUS
    ) {
      return;
    } else if (
      this.minValue != this.MIN_VALUE_CACAUS &&
      this.maxValue == this.MAX_VALUE_CACAUS
    ) {
      let list2 = [this.minValue, this.maiorValor];
      return this.obterString(list2);
    } else {
      return this.obterString(list);
    }
  }

  private obterString(lista: any): string {
    this.buttonFiltrar = true;
    return '[' + lista.join(',') + ']';
  }

  private obterMembro(): void {
    var membro = this.authService.LocalStorage.obterMembro();
    this.membro = membro;
    if (membro.tipoStatus === 7 || membro.tipoStatus === 11) {
      this.router.navigate(['/meusdados']);
    }
  }

  public obterFiltrosSelecionados(lista: any[]): any[] {
    return lista.filter((x) => x.selecionado);
  }

  public desmarcarItem(item: any): void {
    item.selecionado = false;

    this.aplicarFiltros();
  }

  public desmarcarCampanha(): void {
    this.campanhaSelecionada = undefined;

    this.aplicarFiltros();
  }

  public desmarcarOrdem(): void {
    this.ordemSelecionada = undefined;

    this.aplicarFiltros();
  }

  public desmarcarRange(): void {
    this.minValue = this.MIN_VALUE_CACAUS;
    this.maxValue = this.MAX_VALUE_CACAUS;

    this.aplicarFiltros();
  }
}
